import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import { isWithinInterval, addDays } from 'date-fns';
import { Notice } from '@applyboard/crystal-ui';
import { useTranslation } from '@applyboard/ui-utils';
import { useApplication } from "../../data";
import { convertTimelessDateStrToLocalDate } from "../../../../utils/dates";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function NewViewNotice(_ref) {
  var isAdmin = _ref.isAdmin;
  var storedDismissedBanner = localStorage.getItem('ab-application-dismissedNewViewBanner-v2');
  var _useState = useState(Boolean(storedDismissedBanner === 'true')),
    _useState2 = _slicedToArray(_useState, 2),
    hasDismissedBanner = _useState2[0],
    setHasDismissedBanner = _useState2[1];
  var _useTranslation = useTranslation('NewViewNotice'),
    t = _useTranslation.t;
  var _useApplication = useApplication(),
    _useApplication$appli = _useApplication.application,
    newView = _useApplication$appli.newView,
    newViewReleaseDate = _useApplication$appli.newViewReleaseDate;
  var handleClose = function handleClose() {
    setHasDismissedBanner(true);
    localStorage.setItem('ab-application-dismissedNewViewBanner-v2', 'true');
  };
  var releaseDate = newViewReleaseDate ? convertTimelessDateStrToLocalDate(newViewReleaseDate) : null;
  var isValidReleaseWithinOneWeek = releaseDate !== null && isWithinAWeek(releaseDate);
  if (hasDismissedBanner || !newView && !isValidReleaseWithinOneWeek) {
    return null;
  }
  var bannerText = newView ? t('newView') : isAdmin ? t('comingSoonAdmin') : t('comingSoon', {
    releaseDate: newViewReleaseDate
  });
  return _jsxs(Notice, {
    children: [bannerText, _jsx(Notice.ButtonLink, {
      href: "https://www.applyboard.com/info/application-whats-new",
      mode: "override_user_choice_and_open_in_new_tab",
      children: t('learnMore')
    }), _jsx(Notice.CloseButton, {
      onClick: handleClose
    })]
  });
}
var isWithinAWeek = function isWithinAWeek(date) {
  var today = new Date();
  return isWithinInterval(date, {
    start: today,
    end: addDays(today, 7)
  });
};